import { DeleteContentOutDto, DeleteContentInDto } from '../../../types/content.dto'

export const DELETE_CONTENT = 'DELETE_CONTENT'
export const DELETE_CONTENT_SUCCESS = 'DELETE_CONTENT_SUCCESS'
export const DELETE_CONTENT_ERROR = 'DELETE_CONTENT_ERROR'
export const RESET_DELETE_CONTENT = 'RESET_DELETE_CONTENT'

export interface DeleteContent {
  type: typeof DELETE_CONTENT
  payload: DeleteContentOutDto
}

export interface DeleteContentSuccess {
  type: typeof DELETE_CONTENT_SUCCESS
  payload: DeleteContentInDto
}

export interface DeleteContentError {
  type: typeof DELETE_CONTENT_ERROR
  payload: string | boolean
}

export interface ResetDeleteContent {
  type: typeof RESET_DELETE_CONTENT
  payload: null
}

export interface State {
  data: DeleteContentInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = DeleteContent | DeleteContentSuccess | DeleteContentError | ResetDeleteContent
